import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { CreateEventAnnoucements } from "../../Config/API/announcements";
import { PROFILE } from "../../Store/Features/ProfileSlice";
import { error, success } from "../Alerts/Message";
import useVariables from "./useVariables";

export function useCreateAnnoucement(setPOSTS, role) {
  const [postloading, setPostLoading] = useState(false);
  const [uploadingMedia, setuploadingMedia] = useState(""); //image,video
  const [Luploading, setLuploading] = useState(false); //image,video
  const [text, setText] = useState("");

  const [IMAGE, setimage] = useState([]);
  const [VIDEO, setvideo] = useState([]);
  const { PID } = useVariables();
  const ID = useSelector(PROFILE);
  const { id } = useParams();

  const CreateAnnoucement = async () => {
    var flag = String(role).toLowerCase();

    if (IMAGE?.preview || VIDEO?.preview || String(text).trim().length > 0) {
      const formData = new FormData();
      const user = PID;
      if (uploadingMedia !== "error" && uploadingMedia !== "")
        formData.append("fileType", uploadingMedia);
      else formData.append("fileType", null);
      if (uploadingMedia === "image") {
        let allMedia = [...IMAGE];
        allMedia.forEach((file) => {
          formData.append("file", file.file);
        });
      } else if (uploadingMedia === "video") {
        let allMedia = [...VIDEO];
        allMedia.forEach((file) => {
          formData.append("file", file.file);
        });
      }
      if (String(text).trim().length > 0) formData.append("text", text);
      if (role === "Player") {
        formData.append("teamId", ID?._id);
        formData.append("playerId", user);
      } else if (role === "Organizer") {
        formData.append("panelId", ID?._id);
        formData.append("organizerId", user);
      }

      formData.append("eventId", id);
      formData.append("user", user);
      formData.append("userRole", role);
      formData.append("flag", flag);

      setPostLoading(true);
      let res = await CreateEventAnnoucements(formData);

      const data = await res.json();

      if (data.type === "success") {
        setPostLoading(false);
        setuploadingMedia("");
        setText("");
        success("Posted successfully!");
        setPOSTS((prevPosts) => [...data.data, ...prevPosts]);
        setPostLoading(false);
      } else {
        setPostLoading(false);
        setuploadingMedia("error");
        setText("");
        error(data?.result || "An Error Occurred!");
      }
      setPostLoading(false);
    } else {
      error("Add something before posting!");
    }
  };
  // for selecting either image or video at a time
  useEffect(() => {
    if (uploadingMedia === "video") {
      setimage([]);
    } else if (uploadingMedia === "image") {
      setvideo([]);
    } else if (uploadingMedia === "error") {
      setimage([]);
      setvideo([]);
    }
  }, [uploadingMedia]);

  useEffect(() => {
    return () => {
      setPostLoading(false);
      setuploadingMedia(false);
      setPOSTS(null);
      setvideo(null);
      setimage(null);
      setText(null);
      setLuploading(false);
    };
  }, []);

  return {
    uploadloading: postloading,
    setPostLoading,
    IMAGE,
    VIDEO,
    setimage,
    setvideo,
    text,
    setText,
    uploadingMedia,
    setuploadingMedia,
    CreateAnnoucement,
    Luploading,
    setLuploading
  };
}
